<template>
  <div id="app" :data-partner="partner">
    <router-view v-if="$route.name === 'change_password' && $route.params.code" :locale="locale"></router-view>
    <div v-else-if="isLogin" id="wrap">
      <div id="menu">
        <Nav :locale="locale" />
      </div>
      <div id="container">
        <Header :locale="locale" id="header" @logout="logout" />
        <div id="content">
          <router-view v-if="rendered" class="contentWrap" :locale="locale" :isIdle="isIdle"></router-view>
        </div>
      </div>
    </div>
    <router-view v-else :locale="locale"></router-view>
    <Loading v-if="isLoading" />
    <Idle v-if="isLogin && isIdle" :locale="locale" @logout="logout" />
    <!-- <QRREADER /> -->
  </div>
</template>

<script>
import Idle from '@/views/Idle'
import Nav from '@/views/Nav.vue'
import Header from '@/views/Header.vue'
import Loading from '@/views/Loading.vue'
// import QRREADER from '@/views/QR_READER'

export default {
  components: {
    Idle,
    Nav,
    Header,
    Loading,
    // QRREADER
  },
  created () {
    this.$store.commit('service/setPartner')
    this.init()
  },
  computed: {
    isIdle () {
      return this.$store.state.idleVue.isIdle
    },
    isLogin () {
      return this.$store.getters['authentication/isLogin']
    },
    partner () {
      return this.$store.state.service.partner
    },
    locale () {
      return this.$store.state.service.locale.data
    },
    isLoading () {
      return this.$store.state.loading
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.$store.dispatch('setting/initLang')
    },
    isLogin (isLogin) {
      if (isLogin) {
        this.init()
      } else {
        this.$router.push({ name: 'login', path: '/' })
      }
    }
  },
  data () {
    return {
      rendered: false
    }
  },
  methods: {
    init () {
      this.$store.state.idleVue.isIdle = false
      this.$store.dispatch('authentication/setAuthInfo').then((res) => {
        if (res) {
          this.$store.commit('onLoading', true)
          this.$store.dispatch('setCommon')
            .then(() => {
              this.rendered = true
              this.$store.commit('onLoading', false)
            })
        }
      })
    },
    logout (isIdle) {
      if (!window.confirm(this.locale.confirm_logout)) return null
      this.$store.dispatch('authentication/logout').then(() => {
        setTimeout(() => {
          if (isIdle) {
            alert('The connection has been terminated because no activity has been detected for 60 minutes.')
          }
        }, 500)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#wrap {
  display: flex;
  flex-direction: row;
  height: 100%;
}
#menu {
  display: flex;
  flex-basis: 240px;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  color: $color-lgrey;
  background-color: $color-black;
  transition: all 0.3s;
}
#container {
  display: flex;
  flex: 1;
  flex-direction: column;
}
#header {
  display: flex;
  position: relative;
  align-items: center;
  height: 40px;
  padding-left: 15px;
  padding-right: 15px;
  border-bottom: 1px solid $color-lgrey2;
  background-color: $color-white;
  z-index: 1;
  transition: all 0.3s;
}
#content {
  height: calc(100% - 40px);
  padding: 10px;
  .contentWrap {
    display: flex;
    position: relative;
    height: 100%;
  }
}
.editMode {
  #menu {
    flex-basis: 70px;
  }
}
</style>
